var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5072_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#25B7D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72478 17.4514L14.2873 15.7508C12.8395 14.6005 11.3917 13.4502 9.944 12.2998L7.38861 13.0811L8.72478 17.4514ZM8.72478 17.4514H31.0489V30.244C31.0489 31.1625 30.2974 31.914 29.3788 31.914H10.3948C9.47627 31.914 8.7247 31.1624 8.7247 30.244L8.72478 17.4514ZM22.4914 24.6827L19.8868 23.179L17.2822 21.6752V24.6827V27.6903L19.8868 26.1866L22.4914 24.6827ZM16.2484 15.1513C14.8006 14.0009 13.3528 12.8506 11.9051 11.7003L16.0449 10.4347C17.4926 11.585 18.9405 12.7353 20.3881 13.8856L16.2484 15.1513ZM22.3492 13.286L26.4888 12.0204L26.3635 11.9209L22.1456 8.56945L18.006 9.83508C19.4536 10.9854 20.9014 12.1357 22.3492 13.286ZM28.4499 11.4209C27.0022 10.2705 25.5545 9.12023 24.1067 7.96992L28.8379 6.52344L30.174 10.8938L28.4499 11.4209Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5072_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.546e8a7f5e3dad795c66d3becd15f2c0.svg";
export { ForwardRef as ReactComponent };